"use client";

import Link from "next/link";
import AppLogo from "@/components/ui/AppLogo";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-charcoal text-cream/80">
      <div className="max-w-7xl mx-auto px-8 md:px-12 py-20">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 pb-12 border-b border-cream/10">
          <Link href="/homepage" className="flex items-center gap-3 group">
            <AppLogo
              text="HÅR Extension"
              iconName="SparklesIcon"
              size={32}
              className="opacity-80 group-hover:opacity-100 transition-opacity"
            />
          </Link>

          {/* Contact Information */}
          <div className="flex flex-col gap-4 text-base">
            <a href="tel:+971585675600" className="text-cream/60 hover:text-gold-light transition-colors">
              📞 {t('footer.phone')}
            </a>
            <a href="mailto:info@harextension.com" className="text-cream/60 hover:text-gold-light transition-colors">
              ✉️ {t('footer.email')}
            </a>
            <p className="text-cream/60">
              📍 {t('footer.location')}
            </p>
          </div>

          <div className="flex items-center gap-5">
            <a
              href="https://wa.me/971585675600"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-cream/10 hover:bg-[#25D366] flex items-center justify-center transition-all duration-300 hover:scale-110"
              aria-label="WhatsApp"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-cream/10 hover:bg-gold flex items-center justify-center transition-all duration-300 hover:scale-110"
              aria-label="Instagram"
            >
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-5 pt-10 text-sm text-cream/40 font-medium tracking-wide">
          <p>{t('footer.copyright')}</p>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-cream/50">{t('footer.location')}</span>
          </div>
          <div className="flex gap-8">
            <Link href="#" className="hover:text-cream/80 transition-colors">{t('footer.privacyPolicy')}</Link>
            <Link href="#" className="hover:text-cream/80 transition-colors">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}